// src/sectors/pilates/reports/staff/tabs/MemberRelationsTab.jsx
import React from 'react';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

export default function MemberRelationsTab() {
  return (
    <Card>
      <MDBox p={2} display="flex" alignItems="center" gap={1.2}>
        <Icon color="info">info</Icon>
        <MDBox>
          <MDTypography fontWeight="bold">Üye İlişkileri</MDTypography>
          <MDTypography variant="button" color="text" sx={{ opacity: 0.8 }}>
            Burayı sonra dolduracağız. (Eğitmen → üye bazlı ilişki, paket/ödeme/katılım kırılımı
            vb.)
          </MDTypography>
        </MDBox>
      </MDBox>
    </Card>
  );
}
